<template src='./conciliationSummary.pug' lang='pug'></template>

<script>
import MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import BetterInputTag from '../../../input/betterInputTag/BetterInputTag'
import InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import TreeGrid from '../../../treeGrid/TreeGrid'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import language from '../../../../../build/language/index'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'
import { VueTabs, VTab } from 'vue-nav-tabs'
import CalendarSummary from '../../../reports/conciliationSummary/CalendarSummary'

export default {
  name: 'ConciliationSummary',

  components: {
    MultiSelectModal,
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    BetterInputTag,
    InputEstablishment,
    ButtonPrimary,
    TreeGrid,
    VueTabs,
    VTab,
    CalendarSummary
  },

  data () {
    return {
      establishimentsUrls: {
        establishments: 'conciliationSummary/establishment/list',
        attributes: '/conciliationSummary/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      isAdvancedSearch: true,
      gridId: '#conciliationSummaryGrid',
      CATEGORIES_MODAL: 'categoriesModal',
      dateRange: {},
      treeGridCfg: {},
      firstDate: new Date(),
      finalDate: new Date(),
      itensSelected: [],
      tipoMovimetacao: 'M',
      list: [],
      selectedList: [],
      disableSearchButton: false,
      filter: {},
      allSelectedItems: null,
      dataTableColumns: [],
      showTreegrid: false,
      result: {},
      treeGridFileName: 'ResumoConciliacao',
      exportUrl: EXPORT_TREEGRID,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      idsItensSelected: [],
      firstTime: true,
      filterable: [],
      attList: [],
      columnsFilterable: [],
      showCustomColumns: false,
      establishment: [],
      firstTimeCategorie: true,
      customSetOrder: null,
      situationList: [
        {
          id: 'A',
          nome: this.$t('statusConciliacao.aberto'),
          checked: true
        },
        {
          id: 'C',
          nome: this.$t('statusConciliacao.conciliado'),
          checked: true
        },
        {
          id: 'M',
          nome: this.$t('statusConciliacao.conciliadoManualmente'),
          checked: true
        },
        {
          id: 'D',
          nome: this.$t('statusConciliacao.divergente'),
          checked: true
        },
        {
          id: 'N',
          nome: this.$t('statusConciliacao.naoAplicavel'),
          checked: true
        }
      ],
      selectedStatuses: ['A', 'C', 'M', 'D', 'N'],
      plansSelected: [],
      idsPlansSelected: [],
      firstTimePlan: true,
      isExportFile: false,
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        },
        categories: {
          id: 'id',
          name: 'nome'
        }
      },
      shown: {
        bankAccounts: false,
        categories: false
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }],
        categories: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todas')
        }]
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('extratoBancario.labels.contasBancarias'),
            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
                }
              },
              banco: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1
                }
              },
              agencia: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia
                  }
                  return a.numAgencia >= b.numAgencia
                }
              },
              conta: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1
                  }
                  return +a.conta <= +b.conta ? 1 : -1
                }
              }
            },
            templates: {
              nome: (h, row) => {
                let txt = row.nome
                if (!row.ativo) {
                  txt += ' (' + this.$t('contaBancaria.labels.inativa') + ')'
                }
                return txt
              },
              banco: (h, row) => {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome
                }
                return '-'
              },
              agencia: (h, row) => {
                let txt = '-'
                if (row.agencia) {
                  txt = row.numAgencia
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia
                  }
                }
                return txt
              },
              conta: (h, row) => {
                let txt = row.conta
                if (row.digConta) {
                  txt += '-' + row.digConta
                }
                return txt
              }
            }
          }
        },
        categories: {
          titles: {
            main: this.$t('categoria.titulos.titulo'),
            sub: this.$t('categoria.labels.selecionarCategoria')
          },
          selectedItems: [],
          columns: ['numero', 'nome', 'idContabil', 'tipo'],
          values: [],
          options: {
            columnsClasses: { numero: 'col-md-3', nome: 'col-md-4', idContabil: 'col-md-2', tipo: 'col-md-3' },
            perPage: 5,
            headings: {
              numero: this.$t('categoria.modal.labels.numero'),
              nome: this.$t('categoria.modal.labels.descricao'),
              idContabil: this.$t('categoria.modal.labels.idContabil'),
              tipo: this.$t('categoria.modal.labels.tipo')
            },
            filterable: ['numero', 'nome', 'idContabil', 'tipo'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['numero', 'nome', 'idContabil', 'tipo'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'numero'
            },
            customSorting: {
              numero: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.ordem >= b.ordem ? 1 : -1
                  }
                  return a.ordem <= b.ordem ? 1 : -1
                }
              },
              nome: function (asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
                }
              },
              idContabil: function (asc) {
                return function (a, b) {
                  const idA = a.idContabil
                  const idB = b.idContabil
                  if (idA === null || idB === null) {
                    if (asc) {
                      return idA === null ? -1 : 1
                    }
                    return idA === null ? 1 : -1
                  }
                  if (asc) {
                    return a.idContabil.toLowerCase().localeCompare(b.idContabil.toLowerCase())
                  }
                  return b.idContabil.toLowerCase().localeCompare(a.idContabil.toLowerCase())
                }
              },
              tipo: function (asc) {
                return function (a, b) {
                  if (asc) {
                    return a.tipo.toLowerCase().localeCompare(b.tipo.toLowerCase())
                  }
                  return b.tipo.toLowerCase().localeCompare(a.tipo.toLowerCase())
                }
              }
            },
            templates: {
              idContabil: (h, row) => {
                return row.idContabil || '-'
              },
              tipo: (h, row) => {
                return this.$t(`categoria.modal.labels.${row.tipo}`)
              }
            }
          }
        }
      }
    }
  },

  computed: {
    idsFilterEstablishments () {
      return this.$store.getters.idsFilterEstablishments
    },
    showCalendarTab () {
      return this.$store.getters.allowedFuncionalities.includes(4008)
    },
    showReportTab () {
      return this.$store.getters.allowedFuncionalities.includes(205)
    }
  },

  watch: {
    situationList: {
      handler (val) {
        this.selectedStatuses = []
        val.forEach(st => {
          if (st.checked) {
            this.selectedStatuses.push(st.id)
          }
        })
      },
      deep: true
    }
  },

  methods: {
    getLoadingMessages () {
      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid']
    },

    validate () {
      let self = this
      let promise = null
      return new Promise(resolve => {
        this.$validator.validateAll().then((result) => {
          if (result && self.$refs.dateRange.validate()) {
            if (self.isExportFile) {
              promise = self.download()
            } else {
              self.showTreegrid = true
              startTreeGridLoading(self.gridId, self.getLoadingMessages())
              promise = self.search()
            }
            promise.finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },

    resetFilter () {
      this.selectedEstablishments = []
      this.data.bankAccounts.selectedItems = []
      this.data.bankAccounts.considerInactiveAccounts = false
      this.data.categories.selectedItems = []
      this.situationList.forEach(situation => {
        situation.checked = true
      })
      this.selectedStatuses = ['A', 'C', 'M', 'D', 'N']
    },

    generateFilter () {
      return {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsContas: this.data.bankAccounts.selectedItems.map(selected => selected.id).filter(account => account !== '-1'),
        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,
        idsEstabelecimentos: this.selectedEstablishments.map(selected => selected.id),
        tipoMovimetacao: this.tipoMovimetacao,
        idsCategorias: this.data.categories.selectedItems.map(selected => selected.id).filter(category => category !== '-1'),
        idsPlanosConciliacao: [], // this.data.conciliationPlan.selectedItems.map(selected => selected.id).filter(plan => plan !== '-1'),
        situacoesConciliacao: this.selectedStatuses,
        lang: language.getCookieByName('language')
      }
    },

    download () {
      this.disableSearchButton = true
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchConciliationSummaryToFile', this.generateFilter())
          .then(() => {
            this.disableSearchButton = false
            resolve()
          }).catch((error) => {
            this.error = true
            this.msgError = error.body
            this.$root.$refs.notification.error('GENERAL')
            this.disableSearchButton = false
            reject()
          })
      })
    },

    search () {
      this.disableSearchButton = true
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchConciliationSummary', this.generateFilter())
          .then((response) => {
            window.DisposeGrids()
            this.result = response.data
            this.treeGridCfg = response.data.Cfg.Layout
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            resolve()
          }).catch((error) => {
            this.error = true
            this.msgError = error.body
            this.$root.$refs.notification.error('GENERAL')
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            reject()
          })
      })
    },

    // Método responsável pelo filtro de conta bancária
    openSelectBankAccountsModal () {
      if (this.data.bankAccounts.values.length > 0) {
        this.shown.bankAccounts = true
        return
      }
      this.$store.dispatch('getBankAccounts', '/conciliationSummary/bankAccounts/list')
        .then(response => {
          this.data.bankAccounts.allBankAccounts = response.data.data
          this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find((bankAccount) => {
            return !bankAccount.ativo
          })
          this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter((bankAccount) => {
            return bankAccount.ativo
          })
          this.shown.bankAccounts = true
        })
    },

    // Método responsável pelo filtro de categorias
    openSelectCategoriesModal () {
      if (this.data.categories.values.length > 0) {
        this.shown.categories = true
        return
      }
      this.$store.dispatch('getCategories', {
        url: '/conciliationSummary/loadCategories',
        flTipoCategoria: 'A,C,D',
        validarUso: false
      })
        .then((response) => {
          this.data.categories.values = response.data
          this.shown.categories = true
        })
    },

    closeModal () {
      this.shown.bankAccounts = false
      this.shown.categories = false
    },

    handleTabChange (tabIndex, newTab, oldTab) {
      switch (newTab.id) {
        case 'reportSummary':
          break
        case 'calendarSummary':
          this.$refs.calendarSummary.$children[0].searchConciliationSummary()
          break
        default:
          break
      }
    }
  },

  mounted () {
    this.$refs.calendarSummary.$children[0].searchConciliationSummary()
  }
}
</script>



// WEBPACK FOOTER //
// ConciliationSummary.vue?79a51634